export default "__VITE_ASSET__k_OPg_l8__"